const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

export const TAB_TYPES = ['Parikramas', 'Live', 'Mantras'];

// Canonical taxonomy — mirrors the mobile app's CATEGORY_TYPE_MAP.
// Production `category` values are either a bare base code (e.g. "1", "11", "13")
// or a "<base>-<subcode>" compound (e.g. "5-17", "6-21"). The base drives the render
// type on mobile; the subcode is a sub-identifier the mobile app parses further.
export const CATEGORY_TYPE_MAP = {
  1:  'parikrama',
  2:  'teertha',
  3:  'sewas',
  4:  'video',
  5:  'read',
  6:  'listen',
  7:  'courses',
  8:  'saint',
  9:  'project',
  10: 'deity',
  11: 'live-darshan',
  12: 'container',
  13: 'temple',
  14: 'recently-live'
};

export const CATEGORY_BASE_OPTIONS = Object.entries(CATEGORY_TYPE_MAP).map(([value, desc]) => ({
  value: String(value),
  label: `${value} — ${desc}`,
  category_desc: desc
}));

// Parse a stored `category` string into { base, subcode }.
// "5-17" → { base: '5', subcode: '17' }; "11" → { base: '11', subcode: '' }.
export const parseCategoryValue = (raw) => {
  if (!raw) return { base: '', subcode: '' };
  const [base, subcode] = String(raw).split('-');
  return { base: base || '', subcode: subcode || '' };
};

// Combine base + subcode into the string persisted to `category`.
// Empty subcode → just the base ("11"); with subcode → compound ("5-17").
export const buildCategoryValue = (base, subcode) => {
  if (!base) return '';
  const sub = String(subcode || '').trim();
  return sub ? `${base}-${sub}` : String(base);
};

export const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const tableColumns = [
  { name: 'ID',  selector: row => row.id,       sortable: true, center: true, width: '80px',  style: truncateStyle },
  { name: 'Tab', selector: row => row.tab_type, sortable: true, center: true, width: '110px', style: truncateStyle },
  { name: 'Seq', selector: row => row.seq_id,   sortable: true, center: true, width: '80px',  style: truncateStyle },
  {
    name: 'Heading',
    selector: row => row.heading,
    sortable: true,
    center: true,
    width: '350px',
    cell: row => (
      <div style={{ ...truncateStyle, color: '#5C61F2', fontWeight: 'bold', width: '100%', textAlign: 'center' }}>
        {row.heading || <em style={{ color: '#999' }}>—</em>}
      </div>
    )
  },
  { name: 'Category',      selector: row => row.category,      sortable: true, center: true, width: '110px', style: truncateStyle },
  { name: 'Category Description', selector: row => row.category_desc, sortable: true, center: true, width: '150px', style: truncateStyle },
  {
    name: 'Active',
    selector: row => row.active,
    sortable: true,
    center: true,
    width: '90px',
    id: 'status',
    cell: row => (
      <span style={{
        minWidth: '60px',
        textAlign: 'center',
        borderRadius: '20px',
        padding: '4px 8px',
        backgroundColor: row.active ? '#28a745' : '#6c757d',
        color: '#FFFFFF',
        fontSize: '10px'
      }}>
        {row.active ? 'Active' : 'Inactive'}
      </span>
    )
  },
  // { name: 'Updated On', selector: row => row.updated_on_display, sortable: true, center: true, width: '160px', style: truncateStyle },
  { name: 'Action',     selector: row => row.action,             sortable: false, center: true, width: '160px', id: 'action', style: truncateStyle }
];
